import React,{Component} from 'react';
import './ClientWallet.css';
import NabarClient from '../Components/NabarClient/NabarClient';
import HeaderTool from '../Components/HeaderTool/HeaderTool';
import HandleRes from '../Components/HandleRes/HandleRes';
import iconremove from '../../../image/iconremove.png'
import iconrightwhite from '../../../image/iconrightwhite.svg'
import axios from 'axios'
import arrow from '../../../image/arrow.svg'
import Loading from '../Components/Loading/Loading';

import { LinkAPI } from '../../../API/API'
class ClientWallet extends Component{
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            isLoading:true,
            inRequest:false,
            balance: "",
            amount: 0,
            accountname: "",
            bankname: "",
            accountnumber: "",
            bankaccounts: [],
            searchBankName:"",
            accountnameError: "",
            banknameError: "",
            accountnumberError: "",
            collectMoneyError: "",
            AmountError: "",
            objbankaccountsError: "",
            gridRadios: false,
            donetras: false,
            networkError: false,
            errordatamessage: false,
            errordatamessagetext: '',
            hasError:false,
            banks: [
                "Banque du Caire",
                "Egyptian Arab Land Bank",
                "National Bank of Egypt",
                "Agricultural Bank of Egypt",
                "Bank of Alexandria",
                "Misr Iran Development Bank",
                "Commercial International Bank (CIB)",
                "Industrial Development & Workers Bank of Egypt",
                "Société Arabe Internationale de Banque (SAIB)",
                "Blom Bank",
                "Credit Agricole Egypt",
                "Emirates NBD",
                "Suez Canal Bank",
                "Qatar National Bank Al Ahli (QNB Alahli)",
                "Banque Misr",
                "Bank Audi",
                "Ahli United Bank",
                "Faisal Islamic Bank of Egypt",
                "Housing and Development Bank",
                "Al Baraka Bank of Egypt",
                "National Bank of Kuwait - Egypt (NBK-Egypt)",
                "Abu Dhabi Islamic Bank (ADIB)",
                "Union National Bank Egypt (UNB-E)",
                "Egyptian Gulf Bank (EG BANK)",
                "Arab African International Bank",
                "HSBC Bank Egypt",
                "Arab Banking Corporation (Bank ABC)",
                "Export Development Bank of Egypt",
                "The United Bank of Egypt",
                "First Abu Dhabi Bank (FAB)",
                "Citibank",
                "Arab Bank Plc.",
                "Mashreq Bank",
                "National Bank of Greece",
                "Arab International Bank",
                "Arab Investment Bank (AIBK)",
                "Attijariwafa Bank Egypt",

            ],
        };
        this.getwalletinfo()

    }

    getwalletinfo = () => {
        const Token = localStorage.getItem("userToken")
        axios.get(`${LinkAPI}/api/businessowner/getwalletinfo`, {
            headers: {
                Authorization: `${Token}`,
                lang:"ar"
            }
        }).then(res => {
            this.setState({
                bankaccounts: res.data.bankaccounts,
                balance: res.data.balance,
                isLoading:false,
                networkError: false,
                errordatamessage: false,
                errordatamessagetext: '',
                hasError:false,
            })

        }).catch(error => {
            if (!error.response) {
                this.setState({
                    networkError: true
                })
            } else if (error.response.status === 402) {
                localStorage.removeItem("userToken")
                window.location.replace("AR/SignIn");
            } else if (error.response.data.message) {
                this.setState({
                    errordatamessage: true,
                    errordatamessagetext:error.response.data.message
                })
            } else {
                this.setState({
                    hasError: true,
                })
            }
        })

    }
 
    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        });
    };
    handlePartialbalance = (event) => {
        this.setState({
            gridRadios: true
        });
    };
    handleFullbalance = () => {
        this.setState({
            amount: this.state.balance,
            gridRadios: false
        });
    }
    handleChangeobj = (x) => e => {
        this.setState({
            objbankaccounts: x
        });
    };

    validatetransfer = () => {
        let amountError = "";
        let objbankaccountsError = "";


        if (this.state.amount <= 0 || isNaN(this.state.amount) || this.state.amount > this.state.balance) {
            amountError = "ادخل القيمه صحيحه";
        }
        
        if (!this.state.objbankaccounts) {
            objbankaccountsError = "اختار حساب بنكي";
        }


        if (objbankaccountsError || amountError) {
            this.setState({ objbankaccountsError, amountError });
            return false;
        }
        return true;
    };
    validateaddNewAccount = () => {
        let accountnameError = "";
        let banknameError = "";
        let accountnumberError = "";

        if (this.state.accountname.length < 5 || !isNaN(this.state.accountnames)) {
            accountnameError = "ادخل اسم صاحب الحساب ";
        }
        if (this.state.bankname.length < 5 || !isNaN(this.state.bankname)) {
            banknameError = "اختار اسم البنك";
        }
        if (this.state.accountnumber <= 0 || isNaN(this.state.accountnumber)) {
            accountnumberError = "رقم حساب خطء";
        }
        if (accountnameError || banknameError || accountnumberError) {
            this.setState({ accountnameError, banknameError, accountnumberError });
            return false;
        }
        return true;
    };
    AddAccountBank = event => {
        event.preventDefault();
        const { accountname, bankname, accountnumber } = this.state
        const Token = localStorage.getItem("userToken")
        const isValid = this.validateaddNewAccount();
        if (isValid) {
            this.setState({ inRequest:true})

            axios.post(`${LinkAPI}/api/businessowner/addnewbankaccount`, { bankaccount: { accountname, bankname, accountnumber } }, {
                headers: {
                    Authorization: `${Token}`,
                    lang:"ar"
                }
            }).then(res => {
                // console.log(res.data)
                this.setState({
                    accountname: "",
                    bankname: "",
                    accountnumber: "",
                    accountnameError: "",
                    banknameError: "",
                    accountnumberError: "",
                    inRequest:false

                })
                this.getwalletinfo()
            }).catch(error => {
                this.setState({

                    accountnameError: "",
                    banknameError: "",
                    accountnumberError: "",
                })
                if (!error.response) {
                    this.setState({
                        networkError: true
                    })
                } else if (error.response.status === 402) {
                    localStorage.removeItem("userToken")
                    window.location.replace("/SignIn");
                } else if (error.response.data.message) {
                    this.setState({
                        errordatamessage: true,
                        errordatamessagetext:error.response.data.message
                    })
                } else {
                    this.setState({
                        hasError: true,
                    })
                }
            })
        }
    }
    setbankname = (x)=>{
        this.setState({
            bankname: x,
        });
    }
    handleDeleteAccount = (event) => {
        event.preventDefault();
        this.setState({ inRequest:true})
        const id = event.target.id
        const Token = localStorage.getItem("userToken")
        axios.delete(`${LinkAPI}/api/businessowner/deletebankaccount`, {
            data: { bankaccount_id: id },
            headers: {
                Authorization: `${Token}`,
                lang:"ar"
            }
        }
        ).then(res => {
            // console.log("done")  
            this.getwalletinfo()
            this.setState({ inRequest:false})

        }).catch(error => {
            // console.log(error.response)
           if (!error.response) {
                this.setState({
                    networkError: true
                })
            } else if (error.response.status === 402) {
                localStorage.removeItem("userToken")
                window.location.replace("/SignIn");
            } else if (error.response.data.message) {
                this.setState({
                    errordatamessage: true,
                    errordatamessagetext:error.response.data.message
                })
            } else {
                this.setState({
                    hasError: true,
                })
            }
        })
    }
    confirmtransfer = (event) => {
        event.preventDefault();

        const { objbankaccounts, amount } = this.state
        const Token = localStorage.getItem("userToken")
        const isValid = this.validatetransfer();

        if (isValid) {
            this.setState({ inRequest:true})

            axios.post(`${LinkAPI}/api/businessowner/confirmtransfer`, {
                amount: amount,
                bankaccount: objbankaccounts
            }, {
                headers: {
                    Authorization: `${Token}`,
                    lang:"ar"
                }
            }).then(res => {
                // window.location.reload();
                this.setState({
                    donetras: true,
                    networkError: false,
                    inRequest:false

                })
                setTimeout(() => {
                    window.location.reload();
                    this.setState({
                        inRequest:false
                    })
                }, 1000);
            }).catch(error => {
                this.setState({
                    amountError: "",
                    objbankaccountsError: ""
                })
                if (!error.response) {
                    this.setState({
                        networkError: true
                    })
                } else if (error.response.status === 402) {
                    localStorage.removeItem("userToken")

                    window.location.replace("/AR/SignIn");
                } else if (error.response.data.message) {
                    this.setState({
                        errordatamessage: true,
                        errordatamessagetext:error.response.data.message
                    })
                } else {
                    this.setState({
                        hasError: true,
                    })
                }
            })
        }
    }


    render(){
        document.title ="kayn | المحفطه ";
        document.getElementsByTagName("META")[1].content="كاين | المحفطه     ";
        document.documentElement.lang = 'ar';
        let  filterBankname = this.state.banks.filter(
            (contact)=>{
                return contact.toLowerCase().indexOf(this.state.searchBankName.toLowerCase())!==-1;
            }
        )
        return( 
            <div>
                <div className="AppAR row  mx-0">
                    <div className="col-md-1 px-0 ">
                        <NabarClient />
                    </div>
                    <div className=" client ClientWallet col-md-11  px-lg-5 px-4">
                        <HeaderTool />
                        <h3 className=" fontsize9 ">المحفظه</h3>
                        <div className="row  shadow bg-white">
                            <div className="col-lg-7 col-md-12 px-lg-5 px-3 py-4">
                                <div className="col-md-8 mb-3 shadow text-center p-3">
                                    <p className="fontsize12">
                                    الرصيد الحالي
                                    </p>
                                    <p className="fontsize10 bluecolor">{this.state.balance} جنيه</p>
                                    
                                </div>
                                <p className="fontsize4 ">تسديد</p>
                                    <hr/>
                                <div className="px-0 py-1 mx-0 row">

                                <div className="form-check mx-3 col-12">
                                    <input className="form-check-input"  type="radio" name="gridRadios" id="Fullbalance" onChange={this.handleFullbalance}/>
                                    <label className="form-check-label"  htmlFor="Fullbalance" >
                                    الرصيد الكامل

                                    </label>
                                </div>
                                    <div className="col-md-6 py-2 mx-3">
                                    <input className="form-check-input"  type="radio" name="gridRadios" id="Partialbalance" onChange={this.handlePartialbalance} />
                                    <label className="form-check-label" htmlFor="Partialbalance">
                                    الرّصيد الجزئي
                                    </label>
                                    </div>
                                    <div className="form-group col-md-5 px-3">
                                            <input type="number" className="form-control badge-pill" placeholder="المقدار" name="amount" value={this.state.amount} onChange={this.handleChange} disabled={(this.state.gridRadios ? '' : 'disabled')} />

                                    </div>
                                    <div style={{ fontSize: 12, color: "red" }}>
                                        {this.state.amountError}
                                    </div>
                                </div>
                                <p className="fontsize4">حدد حساب للسداد</p>
                                <hr/>
                                 {(this.state.isLoading?<Loading/>:
                                 this.state.bankaccounts.map((x, i) => (
                                    <div className="p-1 mx-3 row" key={i} >
                                        <div className="col-md-6"  >
                                            <input className="form-check-input" type="radio" name="objbankaccounts" value={this.state.gridRadios} id={"gridRadios" + i} onClick={this.handleChangeobj(x)} />
                                            <label className="form-check-label" htmlFor={"gridRadios" + i}>
                                                {x.accountnumber}
                                            </label>
                                        </div>
                                        <p className=" col-md-6 px-3 text-meuted fontsize12">{x.accountname}</p>

                                        <p className=" col-md-6 px-3 text-meuted fontsize12">{x.bankname}</p>
                                        <div className=" col-md-6 text-right">
                                            <img className="iconremove pointer" src={iconremove} alt="iconremove" id={x._id} onClick={this.handleDeleteAccount} />
                                        </div>

                                    </div>
                                ))
                                )}
                                <div style={{ fontSize: 12, color: "red" }}>
                                    {this.state.objbankaccountsError}
                                </div> 
                                  <button className="text-white badge-pill p-2 pl-1 px-3  mb-2 border shadow bluebg " data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">اضافه</button>
                                  <div className="p-1 mx-3 row">
                                    <div className="collapse col-12 nocounter" id="collapseExample">
                                        <div className="card card-body">

               

                                            <div className="form-group offreadOnly relative ">
                                                <div id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" >
                                                <input type="text" className="form-control badge-pill" placeholder="اختار اسم البنك ..." readOnly  value={this.state.bankname}   />
                                                <img className="mr-1 img_input2 pointer" src={arrow} alt="arrow" />
                                                </div>
                                                <div className="dropdown-menu dropdownmapmenu mt-1" aria-labelledby="dropdownMenuButton">
                                                <input type="text" className="form-control badge-pill col-11 mx-auto" placeholder="بحث"  name="searchBankName" value={this.state.searchBankName} onChange={this.handleChange}/>
                                                    {
                                                        filterBankname.map((x, i) => (
                                                            <a className="dropdown-item pointer" key={i} onClick={()=>this.setbankname(x)}>{x}</a>
                                                        ))}
                                                </div>
                                                
                                                
                                                <div style={{ fontSize: 12, color: "red" }}>
                                                    {this.state.banknameError}
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <input type="text" className="form-control badge-pill" placeholder="اسم صاحب الحساب كما في بطاقة الرقم القومي" name="accountname" value={this.state.accountname} onChange={this.handleChange} />
                                                <div style={{ fontSize: 12, color: "red" }}>
                                                    {this.state.accountnameError}
                                                </div>
                                            </div>

                                            <div className="form-group">

                                                <input type="number" className="form-control badge-pill" placeholder="رقم الحساب البنكي" name="accountnumber" value={this.state.accountnumber} onChange={this.handleChange} />
                                                <div className="mb-2" style={{ fontSize: 12, color: "red" }}>
                                                    {this.state.accountnumberError}
                                                </div>
                                            </div>
                                            <button onClick={this.AddAccountBank} className="btn btn-primary badge-pill col-md-4 mx-auto"disabled={(this.state.inRequest?true:false)}>اضافه</button>
                                        </div>
                                    </div>
                                </div>
                                <hr/>
                                <p className="fontsize5">الرصيد للتحويل<span className="mx-5 bluecolor">{this.state.amount}جنيه</span></p>
                                <div className="text-center d-flex justify-content-around  flex-wrap my-3 col-md-8">
                                    <button onClick={this.confirmtransfer} className="text-white badge-pill p-2 pl-1 px-3 border my-2 shadow bluebg "disabled={(this.state.inRequest?true:false)}><img className="ml-1" src={iconrightwhite} alt="rightwhite" />تأكيد التحويل</button>
                                    {/* <button className=" text-white  btn badge-pill p-2 pl-1 px-3 my-2 border shadow bg-danger" ><img className="ml-1 " src={closeicon} alt="iconclose" />إلغاء التحويل</button> */}
                                </div>
                            </div>
                            <div className="col-lg-5 d-none d-xl-block d-lg-block picbg2">

                            </div>
                        </div>
                    </div>
                </div>
                {(this.state.networkError ? <HandleRes title="تاكد باتصالك بالانترنت تم عاود المحاوله" stylecss="alert-danger"/> : '')}
                {(this.state.donetras ? <HandleRes title="تم تقديم طلب للتحويل" stylecss="alert-success"/> : '')}
                {(this.state.errordatamessage ? <HandleRes title={this.state.errordatamessagetext} stylecss="alert-danger"/> : '')}
                {(this.state.hasError ? <HandleRes title="  هناك مشكلة في طلبك" stylecss="alert-danger"/> : '')}

            </div>
        )
    }
}
export default ClientWallet;